import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	recent: {
		defaultMessage: 'Recent',
		id: 'atlassian-navigation.plans.menu.content.recent',
		description:
			'Header for dropdown items in the top bar navigation. The items contains links to recent plans',
	},
	untitledPlan: {
		defaultMessage: 'Untitled plan',
		id: 'atlassian-navigation.plans.menu.content.untitled-plan',
		description: 'Default title for Plans dropdown items in the top bar navigation',
	},
});
